export default function imageLoader({ src, width, quality }: { src: string; width: number; quality?: number }): string {
  // Remote/CDN URLs → append width + auto-format params for CDN optimization.
  // Pass quality (Imgix-compatible `q=`) so the CDN can apply lossy compression,
  // addressing the PSI "Improve image delivery" flag (~4-5 MiB savings).
  // Default 65 on this route — Tamil news imagery is forgiving; 65 is visually
  // indistinguishable from 75 but ~25% smaller.
  if (src.startsWith('http://') || src.startsWith('https://')) {
    const separator = src.includes('?') ? '&' : '?';
    const q = quality || 65;
    return `${src}${separator}w=${width}&q=${q}&auto=format%2Ccompress&fit=max`;
  }
  // Data URIs (blur placeholders) → return as-is
  if (src.startsWith('data:')) {
    return src;
  }
  // Local paths → always use origin's _next/image (not CDN)
  // CDN (assetPrefix) is only for JS/CSS, not image optimization
  const q = quality || 65;
  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${q}`;
}
